import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath } from "../../../../../utils";


export default function view() {
    const { $charge, $inputs } = this;

    return (view = ViewFactory({
        NAME: 'PAYMOB_INIT_VIEW',
        inputs: [
            'billing_zip',
            'billing_city',
            'billing_address',
            'billing_state',
            'billing_country',
            'card_holder_name',
            'phonenumber',
        ],

        next() {
            let data = {};

            const billingzip = getValueAtPath($inputs, '[billing_zip].value');
            const billingcity = getValueAtPath($inputs, '[billing_city].value');
            const billingaddress = getValueAtPath($inputs, '[billing_address].value');
            const billingstate = getValueAtPath($inputs, '[billing_state].value');
            const billingcountry = getValueAtPath($inputs, '[billing_country].value.sortname');
            const card_holder_name = getValueAtPath($inputs, '[card_holder_name].value');
            const phonenumber = getValueAtPath($inputs, '[phonenumber].value');
        
            if (billingaddress && billingzip && billingcity && billingstate && billingcountry && card_holder_name && phonenumber) {
                data = { 
                    billingaddress,
                    billingcity,
                    billingcountry,
                    billingstate,
                    billingzip,
                    card_holder_name,
                    phonenumber
                }

                $charge.init({ data });
            }
        }
    }).call(this));
}